import React from "react";
import { LanguageItem } from "./LanguageItem";
import DropdownButton from "../Buttons/DropdownButton";
import { useTranslation } from "react-i18next";
import { LANGUAGE, FLAGS } from "../../utils/constants";

export const LanguageSelector = () => {
    const { i18n } = useTranslation();

    const changeLanguage = (language) => {
        i18n.changeLanguage(language);
    };

    const options = [
        {
            label: "English",
            callback: () => changeLanguage(LANGUAGE.English),
            displayName: (
                <LanguageItem
                    flag={FLAGS.states}
                    language={LANGUAGE.English}
                    label="English"
                />
            ),
        },
        {
            label: "Portuguese",
            callback: () => changeLanguage(LANGUAGE.Portuguese),
            displayName: (
                <LanguageItem
                    flag={FLAGS.portugal}
                    language={LANGUAGE.Portuguese}
                    label="Portuguese"
                />
            ),
        },
        {
            label: "Chinese",
            callback: () => changeLanguage(LANGUAGE.Chinese),
            displayName: (
                <LanguageItem
                    flag={FLAGS.china}
                    language={LANGUAGE.Chinese}
                    label="Chinese"
                />
            ),
        },
        {
            label: "Polish",
            callback: () => changeLanguage(LANGUAGE.Polish),
            displayName: (
                <LanguageItem
                    flag={FLAGS.poland}
                    language={LANGUAGE.Polish}
                    label="Polish"
                />
            ),
        },
        {
            label: "Spanish",
            callback: () => changeLanguage(LANGUAGE.Spanish),
            displayName: (
                <LanguageItem
                    flag={FLAGS.spain}
                    language={LANGUAGE.Spanish}
                    label="Spanish"
                />
            ),
        },
        {
            label: "Turkish",
            callback: () => changeLanguage(LANGUAGE.Turkish),
            displayName: (
                <LanguageItem
                    flag={FLAGS.turkey}
                    language={LANGUAGE.Turkish}
                    label="Turkish"
                />
            ),
        },
        {
            label: "German",
            callback: () => changeLanguage(LANGUAGE.German),
            displayName: (
                <LanguageItem
                    flag={FLAGS.germany}
                    language={LANGUAGE.German}
                    label="German"
                />
            ),
        },
        {
            label: "French",
            callback: () => changeLanguage(LANGUAGE.French),
            displayName: (
                <LanguageItem
                    flag={FLAGS.france}
                    language={LANGUAGE.French}
                    label="French"
                />
            ),
        },
    ];

    return (
        <div className="language-selector-wrapper">
            <DropdownButton
                options={options}
                icon="fas fa-globe"
                className="bg-white text-primary-blue"
                menuClassNames="w-32"
                optionsItemClassNames="text-primary-blue language-option-hover"
                removeArrow={true}
                iconSize="fa-xl"
            />
        </div>
    );
};
